import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.list-report-access-grants.ReportAccessGrantListView`

export default defineMessages({
  removeGrantLabel: {
    id: `${scope}.removeGrantLabel`,
    defaultMessage: 'Remove {userFullName}',
  },
  clearAllLabel: {
    id: `${scope}.clearAllLabel`,
    defaultMessage: 'Clear all ({count})',
  },
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage:
      'No users have been given access to this {singularSecondaryOrgCategoryLabel}.',
  },
  emptyStateContent: {
    id: `${scope}.emptyStateContent`,
    defaultMessage:
      'Users who have been given access to report information for this {singularSecondaryOrgCategoryLabel} will appear here.',
  },
})
